import { render, staticRenderFns } from "./CreatePAAccount.vue?vue&type=template&id=21aea4cd&scoped=true"
import script from "./CreatePAAccount.vue?vue&type=script&lang=js"
export * from "./CreatePAAccount.vue?vue&type=script&lang=js"
import style0 from "./CreatePAAccount.vue?vue&type=style&index=0&id=21aea4cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aea4cd",
  null
  
)

export default component.exports